import RootComponent from './RootComponent';

export default RootComponent;
